import { navFromHash } from '../../path'
import { prepareNav, LIST_TYPES_JST } from '../../routeHelpers'

function jstSelectListType(listType) {
  if (!LIST_TYPES_JST.find(x => x === listType)) {
    listType = 'tereny'
  }
  return listType
}

export default {
  namespaced: false,
  state: {
    nav: navFromHash(window.location.hash) || {
      type: 'list', // 'nav', 'details'
      listType: undefined, // 'tereny', 'hale', 'biura', 'inwestorzy'

      // list
      powiatId: undefined,
      gminaId: undefined,

      // details
      id: undefined,
    },
  },
  getters: {
    currentPowiatId: (state, getters) => (state.nav.gminaId && getters['jst/gminaById'](state.nav.gminaId) && getters['jst/gminaById'](state.nav.gminaId).powiat_id) || state.nav.powiatId,
    nav: state => state.nav,
    navType: state => state.nav.type,
    listType: state => state.nav.listType,
    listExpanded: state => listType => state.nav.listType == listType,
    powiatExpanded: (state, getters) => (listType, powiat) => state.nav.listType == listType && getters.currentPowiatId == powiat.id,
    gminaExpanded: state => (listType, gmina) => state.nav.listType == listType && state.nav.gminaId == gmina.id,
    currentOferta: (state, getters) => getters['currentTeren'] || getters['currentInwestor'],
    currentTeren: (state, getters) => state.nav.listType == 'tereny' && getters['tereny/getById'](state.nav.id),
    currentHala: (state, getters) => state.nav.listType == 'hale' && getters['hale/getById'](state.nav.id),
    currentBiuro: (state, getters) => state.nav.listType == 'biura' && getters['biura/getById'](state.nav.id),
    currentInwestor: (state, getters) => state.nav.listType == 'inwestorzy' && getters['inwestorzy/getById'](state.nav.id),
    currentItem: (state, getters) => state.nav.listType && getters[state.nav.listType + '/getById'](state.nav.id),
    currentCenterPowiat: (state, getters) => state.nav.powiatId && getters['jst/powiatById'](state.nav.powiatId),
    currentCenterGmina: (state, getters) => state.nav.gminaId && getters['jst/gminaById'](state.nav.gminaId),
    currentCenter: (state, getters) => {
      switch (state.nav.type) {
        case 'list':
          if (state.nav.gminaId) {
            return {
              type: 'gmina',
              item: getters.currentCenterGmina,
            }
          } else if (state.nav.powiatId) {
            return {
              type: 'powiat',
              item: getters.currentCenterPowiat,
            }
          } else {
            return {
              type: 'strefa',
            }
          }
        case 'details':
          return {
            type: state.nav.listType + 'Details',
            item: getters.currentItem,
          }
      }
    }
  },
  mutations: {
    setNav(state, data) {
      state.type = 'nav'
      state.nav = data
    }
  },
  actions: {
    setNav(ctx, data) {
      ctx.commit('setNav', prepareNav(data))
    },
    toggleList(ctx, { listType }) {
      if (ctx.state.nav.listType == listType) {
        listType = undefined
      }
      ctx.dispatch('showList', { listType, powiatId: undefined, gminaId: undefined })
    },
    togglePowiat(ctx, { listType, powiat }) {
      let powiatId = powiat.id
      if (ctx.getters.currentPowiatId == powiatId) {
        powiatId = undefined
      }
      ctx.dispatch('showList', { listType, powiatId, gminaId: undefined })
    },
    toggleGmina(ctx, { listType, gmina }) {
      let gminaId = gmina.id
      if (ctx.state.nav.gminaId == gminaId) {
        gminaId = undefined
      }
      ctx.dispatch('showList', { listType, powiatId: gmina.powiat_id, gminaId })
    },
    selectPowiat(ctx, { powiat }) {
      ctx.dispatch('showList', {
        listType: jstSelectListType(ctx.state.nav.listType),
        powiatId: powiat.id,
        gmiknaId: undefined
      })
    },
    selectGmina(ctx, { gmina }) {
      ctx.dispatch('showList', {
        listType: jstSelectListType(ctx.state.nav.listType),
        powiatId: gmina.powiat_id,
        gminaId: gmina.id
      })
    },
    showList(ctx, { listType, powiatId, gminaId }) {
      ctx.dispatch('setNav', { type: 'list', listType, powiatId, gminaId })
    },
    showDetails(ctx, { listType, item }) {
      ctx.dispatch('setNav', {
        type: 'details',
        listType,
        id: item.id,
        // no expanding gmina on back from details
        powiatId: item.properties.powiat_id,
        gminaId: item.properties.gmina_id
      })
    },
    backDetails(ctx) {
      let listType = ctx.state.nav.listType;
      let item = ctx.getters.currentItem;
      if(item == undefined) {
        ctx.dispatch('showList', { listType: undefined, powiatId: undefined, gminaId: undefined })
      }
      else {
        ctx.dispatch('showList', {
          listType,
          powiatId: item.properties.powiat_id,
          gminaId: item.properties.gmina_id
        })
      }
    },
    backGmina(ctx) {
      let listType = ctx.state.nav.listType;
      let powiatId = ctx.getters.currentPowiatId;
      ctx.dispatch('showList', {
        listType,
        powiatId,
        gminaId: undefined
      })
    }
  },
}
